module.exports = __webpack_public_path__ + "img/fyt_p12.6cd677df.png";